import { Injectable, inject } from '@angular/core';
import { AUTH_CONSTANTS } from '@app/auth';
import { ApiService } from '@app/gateway';
import { UserListModel } from '../models';

@Injectable({ providedIn: 'root' })
export class UsersService {
  private readonly apiService = inject(ApiService);

  public async listUsers(): Promise<UserListModel[]> {
    try {
      const path: string = AUTH_CONSTANTS.PATH_LIST;
      return this.apiService.get<UserListModel[]>({ path, base: 'auth' });
    } catch (e: unknown) {
      if (e instanceof Error) {
        throw new Error(e.message, { cause: e });
      }
      throw new Error('Ocorreu um erro desconhecido', { cause: e });
    }
  }
}
